
<template>
    <!-- Skip Navigation Link for Accessibility -->
    <a href="#main-content" class="skip-link" @click="skipToMain">
      Zum Hauptinhalt springen
    </a>

    <SiteNavigation/>
    <main id="main-content" role="main" tabindex="-1">
        <router-view />
    </main>
    <SiteFooter/>
</template>
<script>
import SiteNavigation from './SiteNavigation.vue';
import SiteFooter from './SiteFooter.vue';

export default {
    name: 'SiteLayout',
    components: {
    SiteFooter,
    SiteNavigation
  },
  methods: {
    skipToMain(event) {
      event.preventDefault();
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        mainContent.focus();
        mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
};
</script>

<style scoped>
/* Skip link for keyboard navigation (EAA compliance) */
/* Hidden by default, only visible when focused with keyboard */
.skip-link {
  position: absolute;
  top: -100px;
  left: 0;
  background: var(--primary-color, #001e46);
  color: var(--color-white, #ffffff);
  padding: 8px 16px;
  text-decoration: none;
  font-weight: 600;
  z-index: 9999;
  border-radius: 0 0 4px 0;
  transition: top 0.3s;
  opacity: 0;
  pointer-events: none;
}

.skip-link:focus {
  top: 0;
  opacity: 1;
  pointer-events: auto;
  outline: 2px solid var(--secondary-color, #00aeef);
  outline-offset: 2px;
}
</style>